import { React, DomeComponent, DomeManipulator } from '@lexriver/dome'
import css from './Checkbox.m.scss'
import { ErrorForInput } from './ErrorForInput'

interface Attrs{
    //checkedByDefault?:boolean
    //sessionStorageKey?:string
    isChecked?:boolean
    smallStyle?:boolean
    onChange?:(value:boolean) => void
}

export class Checkbox extends DomeComponent<Attrs>{
    private errorForInput!:ErrorForInput
    private input!:HTMLInputElement
    //private isChecked:boolean = this.attrs.checkedByDefault||false
    render(){
        // if(this.attrs.sessionStorageKey){
        //     const valueInSessionStorage = sessionStorage.getItem(this.attrs.sessionStorageKey)
        //     if(valueInSessionStorage !== null){
        //         this.attrs.isChecked = valueInSessionStorage?true:false
        //     }
        // }
        return (
            <div class={css.checkbox}>
                <label class={{[css.small]:this.attrs.smallStyle}}>
                <input 
                    type='checkbox'
                    onChange={(e) => this.onChangeAsync(e.target.checked)} 
                    checked={this.attrs.isChecked}
                    ref={(ref:HTMLInputElement) => this.input = ref}
                    />
                    {this.children}
                    <ErrorForInput ref={ref => this.errorForInput = ref} />
                </label>
            </div>
        )
    }

    // afterRender(){
    //     // if(!this.input) return
    //     // this.input.checked = this.isChecked
    //     this.scheduleUpdate()
    // }



    protected async onChangeAsync(checked:boolean){
        //console.log('on input', e.target.value)
        //this.attrs.checkedByDefault = checked
        this.attrs.isChecked = checked
        this.input.checked = checked
        // if(this.attrs.sessionStorageKey){
        //     sessionStorage.setItem(this.attrs.sessionStorageKey, checked?'true':'')
        // }
        //console.log('checked=', this.attrs.checked)
        await this.hideErrorAsync()
        if(this.attrs.onChange){
            this.attrs.onChange(checked)
        }
    }

    async hideErrorAsync(){
        if(!this.errorForInput) return
        await this.errorForInput.hideAsync()
    }

    async showErrorAsync(errorMessage:string|HTMLElement){
        if(!this.errorForInput) return
        await this.errorForInput.showAsync(errorMessage)
        if(!this.input) return
        DomeManipulator.scrollIntoView(this.input)
    }

    async setValueAsync(checked:boolean){
        //console.log('Checkbox.tsx: setValue', checked)
        await this.onChangeAsync(checked)
    }

    getValue(){
        return this.attrs.isChecked
    }

    focus(){
        if(this.input) this.input.focus()
    }

    disable(){
        if(this.input) this.input.disabled = true
    }

    enable(){
        if(this.input) this.input.disabled = false
    }
    
}